/**
 * One hour × tag cell of the preview grid — its look and its plain-words
 * explanation (the reason an hour is Unknown or not tagged).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { HourTagReason, HourTagVerdict } from '@trafficpulse/shared';

export const hourLabel = (hour: number): string => `${String(hour).padStart(2, '0')}:00`;

const STATE_LABEL = { tagged: 'Tagged', not_tagged: 'Not tagged', unknown: 'Unknown' } as const;

function reasonText(reason: HourTagReason, uniqueVisits: number): string {
  switch (reason) {
    case 'no_data':
      return 'no visits recorded in this hour';
    case 'below_floor':
      return `only ${uniqueVisits.toLocaleString('en-GB')} unique visits — under the rule's minimum`;
    case 'report_failed':
      return 'the tracker report failed — try again later';
    case 'compare_missing':
      return 'nothing to compare against in this hour';
    case 'higher_tier_unknown':
      return 'a higher tier of the same group is Unknown';
    case 'higher_tier_tagged':
      return 'a higher tier of the same group took this hour';
    default:
      return 'the tag is not available';
  }
}

export function cellTitle(tag: string, hour: number, v: HourTagVerdict): string {
  const head = `${hourLabel(hour)} · ${tag}: ${STATE_LABEL[v.state]}`;
  if (v.reason) return `${head} — ${reasonText(v.reason, v.uniqueVisits)}`;
  return `${head} (${v.uniqueVisits.toLocaleString('en-GB')} unique visits)`;
}
